<template>
    <div class="access-list" v-if="listAccess" :class="{ 'access-list--fix': headIsFix }">
        <div class="access-list__head">
            <input
                class="access-list__item access-list__item--project-name"
                v-model="seachObject.project_name"
                placeholder="Название проекта"
                @input="sortArray('project_name')"
            />
            <input
                class="access-list__item access-list__item--host"
                v-model="seachObject.host"
                placeholder="Host"
                @input="sortArray('host')"
            />
            <input
                class="access-list__item access-list__item--login"
                v-model="seachObject.login"
                placeholder="Login"
                @input="sortArray('login')"
            />
            <input
                class="access-list__item access-list__item--password"
                v-model="seachObject.password"
                placeholder="Password"
                @input="sortArray('password')"
            />
            <input
                class="access-list__item access-list__item--comment"
                v-model="seachObject.comment"
                placeholder="Комментарий"
                @input="sortArray('comment')"
            />
            <input
                class="access-list__item access-list__item--type"
                v-model="seachObject.type"
                placeholder="Тип"
                @input="sortArray('type')"
            />
            <div class="access-list__item access-list__item--edit">EDIT</div>
            <div class="access-list__item access-list__item--del">DEL</div>
        </div>
        <AccessItem v-for="item in listAccessFind" :key="item.id" :accessData="item" @refresh="refresh" @openedit="openEdit" :current-open="itemOpenEditForm"/>
        <AccessBtnAdd @refresh="refresh" />
    </div>
</template>

<script>
import AccessItem from "@/components/AccessItem.vue";
import AccessBtnAdd from "@/components/AccessBtnAdd.vue";

export default {
    components: {
        AccessItem,
        AccessBtnAdd
    },

    data() {
        return {
            listAccess: false,
            headIsFix: false,
            inputStr: "",
            listAccessFind: false,
            seachObject: {},
            pressed: new Set(),
            itemOpenEditForm: {}
        };
    },

    methods: {
        openEdit(item) {
            this.itemOpenEditForm= item;
        },
        headFix() {
            let head = document.querySelector(".access-list");
            if (head && head.getBoundingClientRect().top <= 0) {
                this.headIsFix = true;
            } else {
                this.headIsFix = false;
            }
        },
        sortArray(nameFindString) {
            this.listAccessFind = this.listAccess.filter(item => {
                return item[nameFindString].includes(
                    this.seachObject[nameFindString]
                );
            });
        },
        refresh(list) {
            this.listAccess = list;
            this.listAccessFind = list;
            this.seachObject = {};
        },
        searchFocus(e) {
            if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) { 
                e.preventDefault();
                let input = document.getElementsByClassName('access-list__item--project-name')[0];
                if (input) {
                    input.focus();
                }
            }
        }
    },

    mounted() {
        this.axios
            .get("/api/get_list/")
            .then(response => {
                this.listAccess = response.data;
                this.listAccessFind = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
    },

    created() {
        window.addEventListener("scroll", this.headFix);
        window.addEventListener("keydown", this.searchFocus)
    },

    destroyed() {
        window.removeEventListener("scroll", this.headFix);
    }
};
</script>

<style lang="sass" scoped>
.access-list--fix
    padding-top: 38px
.access-list
    position: relative
.access-list__head
    display: flex
    justify-content: space-between
    margin: 30px 0
    border-bottom: 1px solid transparent
    +trans(300ms, border-color)
    top: 0
    margin: auto
    border-color: $grey-l
    width: 100%
    z-index: 100
.access-list__item
    width: 20%
    padding: 10px 20px
    background-color: $grey-l
    text-align: center
    border: none
    &::placeholder
        color: inherit
.access-list--fix
    .access-list__head
        position: fixed
        width: calc(100% - 10em - 2px)
.access-list__item--project-name,
.access-list__item--host,
.access-list__item--login,
.access-list__item--password
    width: 15%
.access-list__item--type
    width: 10%
.access-list__item--edit
    width: 5%
    color: $green
.access-list__item--del
    width: 5%
    color: red
.access-list__item--comment
    width: 20%
</style>
